import Http from "./base-http"

class ModuleLog extends Http {
  updateModuleLog(variables) {
    return this.update(variables.id, variables.data)
  }
  createModuleLog(variables) {
    return this.create(variables);
  }
}
const moduleLogObj = new ModuleLog({
  modelUrlPrefix : "moduleLog"
});

export default moduleLogObj
